<template>
  <router-link
      v-slot="{ href, navigate }"
      :to="tagLink()">
    <li
        :class="[
          active && 'active'
        ]"
        :title="text">
      <a
          :href="href"
          @click="navigate">
        <div
            class="icon"
            :style="{ color }">
          {{ icon }}
        </div>
        <span>{{ text }}</span>
      </a>
      <base-button
          v-if="showButtons"
          type="transparent"
          size="small"
          icon="edit"
          @click="editTag(tag)"/>
      <base-button
          v-if="showButtons"
          type="transparent"
          size="small"
          icon="push_pin"
          @click="pinTag(tag)"/>
    </li>
  </router-link>
</template>

<script>
import BaseButton from '@/components/core/BaseButton.vue';
import TagEditModal from '@/components/sidebar/TagEditModal.vue';

export default {
  name: 'TagEntry',
  components: {
    BaseButton,
  },
  props: {
    text: String,
    icon: String,
    color: {
      type: String,
      default: '#ffffff',
    },
    tag: [Object, String],
    showButtons: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    active() {
      if (this.tag === 'untagged') {
        return this.$route.query.untagged;
      }

      if (this.tag === 'archived') {
        return this.$route.query.archived;
      }

      if (this.tag === 'deleted') {
        return this.$route.query.deleted;
      }

      if (this.tag && this.tag.name) {
        return this.$route.query.tag === this.tag.name;
      }

      if (this.tag === undefined) {
        return !this.$route.query.tag && !this.$route.query.untagged
          && !this.$route.query.archived && !this.$route.query.deleted;
      }

      return false;
    },
  },
  methods: {
    tagLink() {
      const query = {};
      if (this.tag === 'untagged') {
        query.untagged = true;
      } else if (this.tag === 'archived') {
        query.archived = true;
      } else if (this.tag === 'deleted') {
        query.deleted = true;
      } else if (this.tag) {
        query.tag = this.tag.name;
      }

      if (this.$route.query.search) {
        query.search = this.$route.query.search;
      }

      return {
        query,
      };
    },
    editTag(tag) {
      this.$modal.show({
        component: TagEditModal,
        properties: {
          tagName: tag.name,
        },
      });
    },
    async pinTag(tag) {
      tag.pinned = !tag.pinned;
      await this.$store.dispatch(
        'tags/updateTag',
        { tag },
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

li {
  align-items: center;
  display: flex;
  width: 100%;
  transition: background .2s;

  &:hover {
    background: $dark-gray-400;

    button {
      display: inline-flex;
      margin: 0 0.375rem 0 0;
    }
  }

  &.active {
    background: $dark-gray-300;

    &:hover {
      background: $dark-gray-100;
    }
  }

  a {
    align-items: center;
    display: flex;
    flex-grow: 1;
    overflow: hidden;

    .icon {
      font-size: 1.5rem;
      height: 2.5rem;
      line-height: 1.5rem;
      padding: 0.5rem 0.75rem;
      width: 3rem;
    }

    span {
      display: hidden;
      flex-grow: 1;
      font-size: 1rem;
      overflow: hidden;
      padding-right: 0.75rem;
      padding: 0.25rem;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  button {
    display: none;
  }
}

</style>
